//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost, axiosGet } from '../../axios/axios.js'
import TableMultiple from '../../components/Table/TableMultiple.vue'

export default {
  components: {
    TableMultiple
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    requestId: {
      type: Number,
      default: null
    },
    // Уже установленные метки (полные объекты)
    alreadyUsedRoadsLabels: {
      type: Array,
      default () {
        return []
      }
    },
    // Метки из типовых комментариев можно редактировать в диалоге (ключи)
    removableRoadsLabelsKeys: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      loading: false,
      selectedRoadsLabelsKeys: [],
      roadsLabels: [],
      roadsLabelsColums: [
        {
          name: 'name',
          label: 'Метка',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'description',
          label: 'Описание',
          align: 'left',
          field: 'description',
          sortable: true
        }
      ]
    }
  },
  computed: {
    alreadyUsedRoadsLabelsKeys: function () {
      return (this.alreadyUsedRoadsLabels || []).map(label => label.key)
    },
    disabledRoadsLabelsKeys: function () {
      return this.alreadyUsedRoadsLabelsKeys.filter(key => !this.removableRoadsLabelsKeys.includes(key))
    },
    addedRoadsLabelsKeys: function () {
      return this.selectedRoadsLabelsKeys.filter(key => !this.alreadyUsedRoadsLabelsKeys.includes(key))
    },
    removedRoadsLabelsKeys: function () {
      return this.alreadyUsedRoadsLabelsKeys.filter(key =>
        this.removableRoadsLabelsKeys.includes(key) &&
        !this.selectedRoadsLabelsKeys.includes(key) &&
        this.roadsLabels.some(record => record.key === key)
      )
    },
    hasRoadsLabelsChanges: function () {
      return this.addedRoadsLabelsKeys.length > 0 || this.removedRoadsLabelsKeys.length > 0
    }
  },
  watch: {
    opened: function (result) {
      if (result) {
        this.selectedRoadsLabelsKeys = []
        this.roadsLabels = []
        this.loadUserRoadsLabels()
      }
    }
  },
  methods: {
    getLabelsToSet: function () {
      const selectedFromCatalog = this.roadsLabels.filter(record =>
        this.selectedRoadsLabelsKeys.includes(record.key)
      )
      // Метки, которых нет в справочнике, но они установлены в заявке
      const preservedLabels = this.alreadyUsedRoadsLabels.filter(label =>
        label &&
        label.key != null &&
        !this.roadsLabels.some(record => record.key === label.key) &&
        !this.removedRoadsLabelsKeys.includes(label.key)
      )

      return [...preservedLabels, ...selectedFromCatalog]
    },
    confirm: function (labelsToSet) {
      this.$emit('confirm', labelsToSet)
    },
    onClose: function () {
      this.$emit('close')
    },
    onSaveRoadsLabels: function () {
      if (!this.hasRoadsLabelsChanges) {
        return
      }

      this.loading = true

      const labelsToSet = this.getLabelsToSet()
      const bodyFormData = new FormData()
      bodyFormData.set('id', this.requestId)
      bodyFormData.set('labels', labelsToSet.map(label => label.key).join(', '))

      axiosPost({
        url: '/service/delta/request/setUserRoadsLabels',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: response.data.result || 'Метки Roads успешно сохранены',
            progress: true,
            timeout: 3000
          })

          this.confirm(labelsToSet)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка сохранения меток Roads',
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadUserRoadsLabels: function () {
      this.loading = true
      const url = '/service/delta/request/getUserRoadsLabel'

      axiosGet({
        url: url,
        onSuccess: (response) => {
          this.roadsLabels = response.data.result || []
          this.selectedRoadsLabelsKeys = this.roadsLabels
            .filter(record => this.alreadyUsedRoadsLabelsKeys.includes(record.key))
            .map(record => record.key)
        },
        onFailure: 'Ошибка загрузки доступных меток Roads',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onSelectedRoadsLabelsKeys: function (itemsIds) {
      const disabledKeys = this.disabledRoadsLabelsKeys.filter(key =>
        this.roadsLabels.some(record => record.key === key)
      )
      this.selectedRoadsLabelsKeys = [...new Set([...disabledKeys, ...itemsIds])]
    }
  }
}

